import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Star as StarIcon } from 'styled-icons/boxicons-solid/Star';
import COLOR from 'constants/colors';

const StyledIcon = styled(StarIcon)`
  cursor: pointer;
  fill: ${({ id }) => `url(#gradient${id})`};
  stroke: rgba(0, 0, 0, 0.12);
  stroke-width: 1;
`;

const StyledSVG = styled.svg`
  display: inline !important;
`;

const Star = ({ value, id, color1, color2, size }) => (
  <>
    <StyledSVG width={size} height={size}>
      <defs>
        <linearGradient id={`gradient${id}`} x1="0%" y1="0%" x2={`${value}%`} y2="0%">
          <stop offset="100%" stopColor={color1} />
          <stop offset="0%" stopColor={color2} />
        </linearGradient>
      </defs>
      <StyledIcon size={size} id={id}></StyledIcon>
    </StyledSVG>
  </>
);

Star.propTypes = {
  value: PropTypes.number.isRequired,
  id: PropTypes.number.isRequired,
  color1: PropTypes.string,
  color2: PropTypes.string,
  size: PropTypes.number,
};

Star.defaultProps = {
  color1: COLOR.SKY,
  color2: COLOR.WHITE,
  size: 20,
};

export default Star;
